module.exports = __webpack_public_path__ + "static/media/lastfm-square.7e4f7c6b.svg";